import React, { forwardRef, useRef, useEffect, useContext } from "react";
import makeStyles from '@mui/styles/makeStyles';

//Services
import * as Service from "../../../services/Service.js";
import swal from "sweetalert";
// materialui table
import MaterialTable from "@material-table/core";
//Import Preloader
import LoadingSpinnerOpaque from "services/LoadingSpinnerOpaque";

import {
  Grid,
  TextField,
  Checkbox,
  Button,
  CardHeader,
  FormControlLabel,
  FormControl,
  Typography,
} from "@mui/material";
import Autocomplete from '@mui/material/Autocomplete';

import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";

import { fr, enGB } from "date-fns/locale"; // import French and English locale



import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import * as api from "../../../actions/api";
import { useTranslation } from "react-i18next";

import { DeleteOutline, Edit, ViewList } from "@mui/icons-material";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers";

// react-tabulator
import "react-tabulator/lib/styles.css"; // required styles
import "tabulator-tables/dist/css/tabulator.min.css"; // theme
import { ReactTabulator, reactFormatter } from "react-tabulator";
import { UserContext } from "../../../context/user-info-context";
import { getARVFacilityList } from "../../../services/Common";

import { format, subMonths } from 'date-fns';
import encryptionService from "../../../services/encryptionService";
const Prescription = (props) => {
  const permissionType = props.permissionType;
  //get DispensingLanguage
  const DispensingLanguage = JSON.parse(
    localStorage.getItem("DispensingLanguage")
  );

  const menukey = "prescriptions";

  const userCtx = useContext(UserContext);
  // const lan = userCtx.userInfo.LangId; //"fr_FR";
  const lan = localStorage.getItem("LangCode");
  // const lan = "fr_FR";

  const classes = useStyles();
  const tableRef = useRef();
  const { useState } = React;
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedPatientData, setSelectedPatient] = useState({});
  const [query, setQuery] = useState("");

  const [fromDate, setFromDate] = useState(new Date());
  // const [fromDate, setFromDate] = useState(subMonths(new Date(), 3));
  const [toDate, setToDate] = useState(new Date());

  const [selectedPrescription, setPrescription] = useState({});
  const [isLoadingPatient, setLoadingPatient] = useState(false);
  const [isLoadingPrescription, setLoadingPrescription] = useState(false);

  const [isDefaulterPrescription, setIsDefaulterPrescription] = useState(false);
  // console.log(111111);
  const [oppositeValue, setOppositeValue] = useState(0);

  const [toggleButtonValue, setToggleButton] = React.useState("1");

  const { t, i18n } = useTranslation();
  const queryClient = useQueryClient();
  const FacilityId = localStorage.getItem("FacilityId");
  const UserInfo = encryptionService.decryptUserInfo();
  
  const IsAllFacility = UserInfo == 0 ? "" : UserInfo[0].IsAllFacility;

  const [FacilityList, setFacilityList] = useState(getARVFacilityList());
  const isFacilityIdFound = FacilityList.some(facility => facility.id == FacilityId);
  const [currFacilityId, setCurrFacilityId] = useState(isFacilityIdFound ? FacilityId : "");


  let prescriptionFilter = null;

  const handleFacilityChange = (event, newValue) => {
    let rowId = '';
    if(newValue == null){
      rowId = '';
    }else{
      rowId = newValue.id;
    }
    
     setCurrFacilityId(rowId);
     let params2={action:"gPrescriberListByFacility","menukey": menukey, "FacilityId":rowId};
     mutategPrescriberListByFacility(params2);

     let params3={action:"gDispenserListByFacility","menukey": menukey, "FacilityId":rowId};
     mutategispenserListByFacility(params3);
    
    
  };
  

  const {  mutate:mutategPrescriberListByFacility } = useMutation(api.gPrescriberListByFacility, {
    onSuccess: (data) => { 
      if (data.status == 200) {  
        
        localStorage.setItem(
          "PrescriberList",
          JSON.stringify(data.data.datalist)
        );
  
      }
    }
  })

  const {  mutate:mutategispenserListByFacility } = useMutation(api.gDispenserListByFacility, {
    onSuccess: (data) => { 
      if (data.status == 200) {  
        
        localStorage.setItem(
          "DispenserList",
          JSON.stringify(data.data.datalist)
        );
  
      }
    }
  })




 
  React.useEffect(() => {
    localStorage.setItem(
      "FacilityId",
      currFacilityId
    );  

 
    setFormData({
      lastName: "",
      firstName: "",
      ipn: "",
      idNumber: "",
      pass: "",
      contactNumber: "",
    });


    prescriptionFilter = null;
    setLoadingPatient(true);
    fetchPatientsForPrescription();

 
    setSelectedPatient({});
    setToggleButton("1");
    prescriptionData.refetch();

   }, [currFacilityId]);


 

  
  const {
    error,
    isError,
    data,
    refetch: fetchPatientsForPrescription,
  } = useQuery(
    ["patients", prescriptionFilter],
    () => api.getPatientsForPrescription(prescriptionFilter),
    {
      onSuccess: (data) => {
        setLoadingPatient(false);
      },
      refetchOnWindowFocus: false,
      enabled: false, // turned off by default, manual refetch is needed
    }
    // { enabled: showPatientList }
  );

  const prescriptionData = useQuery(
    ["prescriptions", selectedPatientData.id],
    () =>
      api.getPrescriptionByPatientIdDate(
        selectedPatientData.id,
        fromDate,
        toDate,
        toggleButtonValue,
        isDefaulterPrescription
      ),
    {
      onSuccess: (data) => {
        // console.log("Success patient prescripiton call");

        // const [fromDate, setFromDate] = useState(new Date());
        // const [toDate, setToDate] = useState(new Date());

        // console.log("fromDate: ", fromDate);
        // console.log("toDate: ", toDate);
        // console.log("prescriptionFilterFromDate: ", prescriptionFilterFromDate);
        // console.log("prescriptionFilterToDate: ", prescriptionFilterToDate);

        // console.log("selectedPatientData: ", selectedPatientData);
        setPrescription(data[0]);

        setLoadingPrescription(false);
      },
      refetchOnWindowFocus: false,
      enabled: false,
    }
  );

  const { mutate } = useMutation(api.deletePrescription, {
    onSuccess: (data) => {
      if (data.data.status == 200) {
        prescriptionData.refetch();
        queryClient.getQueriesData("prescriptions");

        props.openNoticeModal({
          isOpen: true,
          msg: data.data.message,
          msgtype: data.data.success,
        });
      } else {
        props.openNoticeModal({
          isOpen: true,
          msg: data.data.message,
          msgtype: data.data.success,
        });
      }
      // swal(t(DispensingLanguage[lan][menukey]["Poof! Prescription has been deleted!"]),
      // {
      //     icon: "success",
      //   }
      // );
    },
  });

  useEffect(() => {
    // console.log("Calling useEffect for prescription");
    // console.log('oppositeValue useEffect: ', oppositeValue);
    prescriptionData.refetch();
  }, [
    fromDate,
    toDate,
    toggleButtonValue,
    oppositeValue,
    isDefaulterPrescription,
  ]);

  const handleCheckdefaulter = (e) => {
    const { name, checked } = e.target;
    setIsDefaulterPrescription(checked);
  };

  const handleChangeToggle = (event, tmpToggleButtonValue) => {
    if (tmpToggleButtonValue) {
      // console.log("newAlignment: ", tmpToggleButtonValue);
      // console.log("event: ", event);

      if (tmpToggleButtonValue == 2) {
        //when select Patient prescription
        setFromDate(subMonths(new Date(), 3));
      } else if (tmpToggleButtonValue == 3) {
        //when select  prescription by date
        setFromDate(new Date());
      }

      setLoadingPrescription(true);
      setToggleButton(tmpToggleButtonValue);
    }
  };

  const fromDateChangeHandle = (e) => {
    // console.log("fromDateChangeHandle: ", e);
    setLoadingPrescription(true);
    setFromDate(e);
  };

  const toDateChangeHandle = (e) => {
    setLoadingPrescription(true);
    // console.log("toDateChangeHandle: ", e);
    setToDate(e);
  };

  const searchPrescriptionHandle = (e) => {
    // console.log("searchPrescriptionHandle: ", e);
    prescriptionData.refetch();
  };

  const editPrescription = (data) => {
    let route = `prescription/edit/${data.id}`;
    props.history.push(route);
  };

  const addPrescriptionHandle = (e) => {
    if (
      (selectedPatientData.deceased !== null &&
        selectedPatientData.deceased !== undefined) ||
      (selectedPatientData.transferredOut !== null &&
        selectedPatientData.transferredOut !== undefined)
    ) {
      props.openNoticeModal({
        isOpen: true,
        msg: t(DispensingLanguage[lan][menukey]["This patient has died or been transferred"]),
        msgtype: 0,
      });
    } else {
      let route = `prescription/add/${selectedPatientData.id}`;
      props.history.push(route);
    }
  };

  const deletePrescription = (data) => {
    swal({
      title: t(DispensingLanguage[lan][menukey]["Are you sure?"]),
      text: t(
        DispensingLanguage[lan][menukey][
          "Once deleted, you will not be able to recover this Prescription!"
        ]
      ),
      icon: "warning",
      buttons: [
        t(DispensingLanguage[lan][menukey]["No"]),
        t(DispensingLanguage[lan][menukey]["Yes"]),
      ],
      dangerMode: true,
    }).then((willAction) => {
      if (willAction) {
        mutate(data.id);
        // swal(t(DispensingLanguage[lan][menukey]["Poof! Prescription has been deleted!"]),
        //   {
        //     icon: "success",
        //   }
        // );
      }
    });
  };

  function ActionButton(props: any) {
    const rowData = props.cell._cell.row.data;
    // console.log('rowData when click Edit icon: ', rowData);
    // const cellValue = props.cell._cell.value || "Edit | Show";

    let isView = 0;
    if (rowData.status === -1) {
      isView = 1;
    }

    if (rowData.RepeatFromPrescriptionId > 0) {
      isView = 0; //auto copied prescription always not able to delete
    }

    if (permissionType == 1) {
      isView = 0; //then view mode then not show delete button
    }
    

    if (isView) {
      return (
        <>
          {/* <Edit
            onClick={() => {
              editPrescription(rowData);
            }}
          /> */}
          <DeleteOutline
            onClick={() => {
              deletePrescription(rowData);
            }}
          />
        </>
      );
    } else {
      return (
        <>
          {/* <ViewList
            onClick={() => {
              editPrescription(rowData);
            }}
          /> */}
        </>
      );
    }
  }

  function GetStatus(props: any) {
    const rowData = props.cell._cell.row.data;
    let tmpStatusName = "";
    if (rowData.RepeatFromPrescriptionId) {
      tmpStatusName = t(DispensingLanguage[lan][menukey]["Repeated"]) + "-";
    }
    tmpStatusName += rowData.StatusName;
    return <>{tmpStatusName}</>;
  }

  function PatientName(props: any) {
    const rowData = props.cell._cell.row.data;
    let patientName = "";
    if (props.patientList) {
      let patient = props.patientList.find(
        (patient) => patient.id == rowData.patientId
      );
      if (patient && patient.firstName) {
        patientName = patient.firstName + " " + patient.lastName;
      }
    }
    return <>{patientName}</>;
  }

  function DateFormater(props: any) {
    const rowData = props.cell._cell.row.data;
    let date = rowData.prescriptionDate || new Date();
    return <>{format(new Date(date), 'd/MM/yyyy')}</>;
  }

  function PostDateFormater(props: any) {
    const rowData = props.cell._cell.row.data;
    if (rowData.postDate == null) {
      return <></>;
    } else {
      let date = rowData.postDate || new Date();
      console.log("rowData.postDate: ", rowData.postDate);
      return <>{format(new Date(date), 'd/MM/yyyy')}</>;
    }
  }

  function AppointmentDateDateFormater(props: any) {
    const rowData1 = props.cell._cell.row.data;
    /*  let date1 = rowData1.appointmentDate || new Date();
    return <>{format(new Date(date1), 'd/MM/yyyy')}</>; */

    let date1 = rowData1.appointmentDate;
    if (date1) {
      return <>{format(new Date(date1), 'd/MM/yyyy')}</>;
    } else {
      return <></>;
    }
  }

  /* =====Start of Excel Export Code==== */
  const EXCEL_EXPORT_URL = process.env.REACT_APP_API_URL;

  const PrintPDFExcelExportFunction = (reportType) => {
    let finalUrl = EXCEL_EXPORT_URL + "report/print_pdf_excel_server.php";
    let StartDate = format(new Date(fromDate), 'yyyy-MM-dd');
    let EndDate = format(new Date(toDate), 'yyyy-MM-dd');
    let currDate = new Date();
    window.open(
      finalUrl +
        "?action=getPrescriptionWithPatient" +
        "&reportType=" +
        reportType +
        "&menukey=" +
        menukey +
        "&lan=" +
        localStorage.getItem("LangCode") +
        "&TimeStamp=" +
        Date.now() +
        "&selectedPatientData=" +
        selectedPatientData.id +
        "&StartDate=" +
        StartDate +
        "&EndDate=" +
        EndDate +
        "&toggleButtonValue=" +
        toggleButtonValue +
        "&isDefaulterPrescription=" +
        isDefaulterPrescription +
        "&FacilityId=" +
        currFacilityId +
        "&PatientId=" +
        selectedPatientData.id +
        "&currDate=" +
        currDate

      // +"&appointmentDate="+ date1
    );
  };
  /* =====End of Excel Export Code==== */

  const columns = [
    {
      title: t(DispensingLanguage[lan][menukey]["ID Number"]),
      field: "idNumber",
      width: 130,
      headerSort: false,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["PAS#"]),
      field: "pass",
      width: 130,
      headerSort: false,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["IPN#"]),
      field: "ipn",
      width: 130,
      headerSort: false,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Last Name"]),
      width: 100,
      field: "lastName",
      headerSort: false,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["First Name"]),
      width: 100,
      field: "firstName",
      headerSort: false,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Contact#"]),
      width: 100,
      field: "contactNumber",
      headerSort: false,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["M/F"]),
      width: 80,
      field: "gender",
      headerSort: false,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Age"]),
      width: 40,
      field: "age",
      headerSort: false,
      formatter: reactFormatter(<AgeCalculator />),
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Clinic"]),
      width: 90,
      field: "clinic",
      headerSort: false,
      visible: false,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Contact#"]),
      width: 90,
      field: "contactNumber",
      headerSort: false,
      visible: false,
    },
    // { title: 'Registered', field: 'registered' },
    // { title: 'Actions', field: 'custom', hozAlign: 'center',width: 150, formatter: reactFormatter(<ActionButton />) },
  ];

  const prescriptionDetailColumns = [
    {
      title: t(DispensingLanguage[lan][menukey]["Actions"]),
      headerSort: false,
      field: "custom",
      hozAlign: "center",
      width: 65,
      formatter: reactFormatter(<ActionButton />),
      frozen: true,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Appointment Date"]),
      width: 78,
      field: "appointmentDate",
      // headerFilter: true,
      formatter: reactFormatter(<AppointmentDateDateFormater />),
      frozen: true,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Prescription#"]),
      width: 130,
      field: "prescriptionNumbar",
      headerFilter: true,
      frozen: true,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["ID Number"]),
      field: "idNumber",
      headerFilter: true,
      width: 110,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["PAS#"]),
      width: 90,
      field: "patientIdNumber",
      headerFilter: true,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["IPN#"]),
      width: 90,
      field: "ipn",
      headerFilter: true,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Patient Name"]),
      width: 130,
      field: "patientName",
      headerFilter: true,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Contact#"]),
      width: 120,
      field: "patientContactNumber",
      headerFilter: true,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Prescriber"]),
      width: 130,
      field: "prescriberName",
      headerFilter: true,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Cost (CFA)"]),
      width: 70,
      field: "cost",
      hozAlign: "right",
      headerHozAlign: "right",
      visible: false,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Status"]),
      width: 100,
      field: "StatusName",
      formatter: reactFormatter(<GetStatus />),
      headerFilter: true,
      frozen: true,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Rep"]),
      width: 50,
      field: "repeats",
      hozAlign: "right",
      headerHozAlign: "right",
      headerFilter: true,
      frozen: true,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Posted"]),
      width: 70,
      field: "status",
      formatter: "tickCross",
      hozAlign: "center",
      vertAlign: "middle",
      visible: false,
      headerHozAlign: "center",
      frozen: true,
    },
    {
      title: "RepeatFromPrescriptionId",
      width: 70,
      field: "RepeatFromPrescriptionId",
      visible: false,
      frozen: true,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Prescription Date"]),
      width: 75,
      field: "prescriptionDate",
      // headerFilter: true,
      formatter: reactFormatter(<DateFormater />),
      frozen: true,
      // visible: false,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Post Date"]),
      width: 75,
      field: "postDate",
      // headerFilter: true,
      formatter: reactFormatter(<PostDateFormater />),
      frozen: true,
      // visible: false,
    },
    // {
    //   title: t(DispensingLanguage[lan][menukey]['Posted']), width: 70,field: 'status', formatter: (props: any) => {
    //     return props._cell.row.data.status == 1 ? "Yes" : "No"
    //   }
    // }
  ];

  const normalizeTitle = (t, field) => {
    if (Array.isArray(t)) return String(t[0] ?? field ?? "");
    if (t == null) return String(field ?? "");
    return String(t);
  };
  columns.forEach((c) => { c.title = normalizeTitle(c.title, c.field); });
  prescriptionDetailColumns.forEach((c) => { c.title = normalizeTitle(c.title, c.field); });

  const getPrescriptionItems = (prescription) => {
    let list = [];
    if (prescription && prescription.details) {
      prescription.details.map((item, idx) => {
        list.push({
          // rxNumber: prescription.prescriptionNumbar,
          Sl: ++idx,
          ItemCode: item.ItemCode,
          productName: item.product,
        });
      });
    }
    // console.log('list: ', list);
    return list;
  };

  const [formData, setFormData] = useState({
    lastName: "",
    firstName: "",
    ipn: "",
    idNumber: "",
    pass: "",
    contactNumber: "",
  });

  const _ageCalculate = (dob) => {
    let age = null;
    if (dob) {
      var month_diff = Date.now() - dob.getTime();
      var age_dt = new Date(month_diff);
      var year = age_dt.getUTCFullYear();
      age = Math.abs(year - 1970);
    }
    return age;
  };

  const [selectedDate, setSelectedDate] = React.useState(
    new Date("2021-06-15T21:11:54")
  );
  const [selectedEndDate, setSelectedEndDate] = React.useState(
    new Date("2021-09-05T21:11:54")
  );
  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const handleSearch = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const rowClick = (e: any, row: any) => {
    // console.log('selectedPatientData rowClick of patient new value: ', row._row.data);

    setLoadingPrescription(true);
    setSelectedPatient(row._row.data);

    setToggleButton("2"); //select patient tab when click on patient
    setOppositeValue(Math.random()); //when click on patient then call useeffect. this is for only useEffect call
    // prescriptionData.refetch();
  };

  const prescriptionRowClick = (e: any, row: any) => {
    setPrescription(row._row.data);
  };

  const prescriptionRowDoubleClick = (e: any, row: any) => {
    // setPrescription(row._row.data);
    // console.log("prescriptionRowDoubleClick");
    // console.log('rowData when Doubel click: ', row._row.data);
    editPrescription(row._row.data);
  };

  const onSearch = (e) => {
    // const { name, value } = e.target;
    let filterData = formData;
    // filterData[name] = value
    let searchString = [];
    Object.keys(filterData).map((key) => {
      if (filterData[key]) {
        searchString.push(key + "=" + filterData[key]);
      }
    });

    if (e.key === "Enter") {
      //// // selectPatient(null);
      if (searchString.length) {
        // setFilter(searchString.join('&'))
        prescriptionFilter = searchString.join("&");
        // sePatientListVisible(true);
      } else {
        // setFilter(null);
        prescriptionFilter = null;
        // sePatientListVisible(false);
      }

      setLoadingPatient(true);
      fetchPatientsForPrescription();
    }

    // console.log("e.target", e.target.id);
    // console.log("e.target.value", e.target.value);
    // console.log("prescriptionFilter", prescriptionFilter);

    if (e.target.value == "") {
      // console.log("calling Prescription from search");
      setSelectedPatient({});
      setLoadingPrescription(true);
      prescriptionData.refetch();
    }
  };

  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData({ ...formData, [name]: value });
  // };
  // const handleCheck = (e) => {
  //   const { name, checked } = e.target;
  //   setFormData({ ...formData, [name]: checked });
  // };

  const DataSet = [];

  // React.useEffect(() => {
  //   // let token = sessionStorage.getItem("token");
  //   let token = Constants.token;
  //   // console.log("token");
  //   // console.log(token);
  //   if (token) {
  //     loadData();
  //     loadAllData();
  //     // loadProductGroup();
  //   }
  // }, []);

  // React.useEffect(() => {
  //   // console.log("rubel");
  //   loadData();

  //   // console.log("productsAllData");
  //   // console.log(productsAllData);
  // }, [pageNumber, numberRowPerPage, query, productGroupFilter]);

  // const handleChangePage = (data) => {
  //   setPageNumber(data);
  //   setFirstLoad(false);
  // };

  // const handleChangeRowPerPage = (data) => {
  //   setNumberRowPerPage(data);
  // };

  // const checkLogin = () => {
  //   // let token = sessionStorage.getItem("token");
  //   let token = Constants.token;

  //   if (!token) {
  //     swal("Oops!", `token expired. Please login again`, "error");
  //     props.history.push("/login");
  //   }
  // };

  const loadData = () => {
    // const body = {
    //   product_group_id: productGroupFilter || "0",
    //   page_limit: JSON.stringify(numberRowPerPage),
    //   page_number: JSON.stringify(pageNumber + 1),
    //   search_key: query,
    // };
    // Service.default
    //   .postAuthApi("source/product/index.php", body)
    //   .then((res) => {
    //     if (res.status == 200) {
    //       // selectProductsData(res.Productsdata);
    //       // setTotalRow(res.totalRecords);
    //     } else if (res.message == "Unauthorized") {
    //       // loadData()
    //       swal("Oops! token expired", `Please login again`, "error");
    //       props.history.push("/login");
    //       sessionStorage.clear();
    //     }
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
    // console.log("fillproductlist");
    // selectProductsData(Constants.PrescriptionList.Productsdata);
    // setTotalRow(Constants.PrescriptionList.totalRecords);
    // selectPrescriptionItemData(Constants.PrescriptionItemList.Productsdata);
    // setTotalRowPresItem(Constants.PrescriptionItemList.totalRecords);
  };
  // const loadAllData = () => {
  //   // const body = {
  //   //   product_group_id: "0",
  //   //   page_limit: "10",
  //   //   page_number: "0",
  //   // };

  //   // Service.default
  //   //   .postAuthApi("source/product/index.php", body)
  //   //   .then((res) => {
  //   //     if (res.status == 200) {
  //   //       selectProductsAllData(res.Productsdata);
  //   //     }
  //   //   })
  //   //   .catch((err) => {
  //   //     console.log(err);
  //   //   });
  //   selectProductsAllData(Constants.PrescriptionList.Productsdata);

  //   selectPresItemAllData(Constants.PrescriptionItemList.Productsdata);
  // };

  // const loadProductGroup = () => {
  //   Service.default
  //     .getAuthApi("source/product/all_product_groups.php")
  //     .then((res) => {
  //       if (res.status == 200) {
  //         selectProductGroupData(res.Productgroupdata);
  //       } else {
  //         // swal("Oops!", `token expired`, "error");
  //       }
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // };

  const print = () => {};

  function AgeCalculator(props: any) {
    const rowData = props.cell._cell.row.data;
    let age = _ageCalculate(new Date(rowData.dob));
    return <>{age}</>;
  }

  return (
    <>
      <div className={classes.productPageTitle}>
        <div className="d-flex justify-product mb-2">
          <Grid item xs={12} sm={12}>
            <div className="sw_page_heading">
              <div className="sw_heading_title">
                {t(DispensingLanguage[lan][menukey]["Prescription"])}
              </div>
            </div>
          </Grid>
        </div>
        <div>

          {/* start of filter */}
          <Card className="sw_card sw_filter_card">
            <CardContent className="sw_filterCardContent">
              <Grid container spacing={1}>
              

                <Grid item xs={3} sm={3}>
                  <FormControl className={classes.fullWidth}> 
                  <Autocomplete
                        autoHighlight
                        className="sw_chosen_filter"
                        id="FacilityList"
                        disableClearable
                        disabled={IsAllFacility == 1 ? false : true}
                        options={FacilityList}
                        value={FacilityList.find((facility) => facility.id == currFacilityId) || null}
                        onChange={(event, newValue) => handleFacilityChange(event, newValue)}
                        getOptionLabel={(option) => option?.name ?? ""}
                            isOptionEqualToValue={(option, value) => value?.id == null || option?.id === value?.id}
                        renderOption={(props, option) => (
                          <li {...props} key={option.id ?? option.name}>
                            <Typography className="sw_fontSize">{option.name}</Typography>
                          </li>
                        )}
                        
                        renderInput={(params) => (
                        <TextField
                          {...params}
                            label={t(DispensingLanguage[lan][menukey]["Facility"])}
                          variant="standard"
                          hiddenLabel
                        />
                        )}
                      />

                  </FormControl>
                </Grid> 

              
              </Grid>
            </CardContent>
          </Card>
          {/* end of filter */}
          
          <Grid container spacing={3}>
            {/* Patient Manager */}
            <Grid item xs={4} sm={4}>
              <Card className="sw_card">
                <CardHeader
                  title={t(DispensingLanguage[lan][menukey]["Patient Manager"])}
                />
                {/* <form onSubmit = {onSearch}> */}
                <CardContent className="mb-2">
                  <Grid container spacing={1}>
                    {/* new row */}
                    <Grid item xs={6} sm={6}>
                      <TextField variant="standard"
                        id="idNumber"
                        name="idNumber"
                        label={t(DispensingLanguage[lan][menukey]["ID Number"])}
                        value={formData.idNumber}
                        fullWidth
                        autoComplete="family-name"
                        onChange={(e) => handleSearch(e)}
                        onKeyDown={(e) => onSearch(e)}
                      />
                    </Grid>
                    {/* new row */}
                    <Grid item xs={6} sm={6}>
                      <TextField variant="standard"
                        id="pass"
                        name="pass"
                        label={t(DispensingLanguage[lan][menukey]["PAS#"])}
                        value={formData.pass}
                        fullWidth
                        autoComplete="family-name"
                        onChange={(e) => handleSearch(e)}
                        onKeyDown={(e) => onSearch(e)}
                      />
                    </Grid>

                    <Grid item xs={6} sm={6}>
                      <TextField variant="standard"
                        id="ipn"
                        name="ipn"
                        label={t(DispensingLanguage[lan][menukey]["IPN#"])}
                        value={formData.ipn}
                        fullWidth
                        autoComplete="family-name"
                        onChange={(e) => handleSearch(e)}
                        onKeyDown={(e) => onSearch(e)}
                      />
                    </Grid>

                    <Grid item xs={6} sm={6}>
                      <TextField variant="standard"
                        id="contactNumber"
                        name="contactNumber"
                        label={t(DispensingLanguage[lan][menukey]["Contact#"])}
                        value={formData.contactNumber}
                        fullWidth
                        autoComplete="family-name"
                        onChange={(e) => handleSearch(e)}
                        onKeyDown={(e) => onSearch(e)}
                      />
                    </Grid>

                    {/* new row */}
                    <Grid item xs={6} sm={6}>
                      <TextField variant="standard"
                        id="lastName"
                        name="lastName"
                        label={t(DispensingLanguage[lan][menukey]["Last Name"])}
                        value={formData.lastName}
                        fullWidth
                        autoComplete="family-name"
                        onChange={(e) => handleSearch(e)}
                        onKeyDown={(e) => onSearch(e)}
                      />
                    </Grid>

                    <Grid item xs={6} sm={6}>
                      <TextField variant="standard"
                        id="firstName"
                        name="firstName"
                        label={t(DispensingLanguage[lan][menukey]["First Name"])}
                        value={formData.firstName}
                        fullWidth
                        autoComplete="family-name"
                        onChange={(e) => handleSearch(e)}
                        onKeyDown={(e) => onSearch(e)}
                      />
                    </Grid>

                    {/* new row */}
                    <Grid item xs={12} sm={12}>
                      {/* {showPatientList && columns && data && data.length > 0 && */}

                      <div className="sw_relative">
                        {isLoadingPatient && <LoadingSpinnerOpaque />}

                        <div className="uniqueName">
                          <ReactTabulator
                            options={{
                              selectableRowsRangeMode: "click",
                              selectableRows: 1,
                            }}
                            height="400px"
                            layout={"fitColumns"}
                            columns={columns}
                            data={data ? data : []}
                                events={{
                rowClick: (e, row) => rowClick(e, row),
              }}
                          />
                        </div>
                      </div>

                      {/*  } */}
                    </Grid>
                  </Grid>
                </CardContent>
                {/* </form> */}
              </Card>
            </Grid>

            {/* List of Prescriptions */}
            <Grid item xs={8} sm={8}>
              <Card className="sw_card">
                <CardHeader
                  title={
                    t(DispensingLanguage[lan][menukey]["List of Prescriptions"])
                  }
                />
                <CardContent>
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={12}>
                      <ToggleButtonGroup
                        className="sw_ToggleButtonGroup"
                        color="primary"
                        value={toggleButtonValue}
                        exclusive
                        onChange={handleChangeToggle}
                      >
                        <ToggleButton value="1">
                          {
                            t(DispensingLanguage[lan][menukey][
                              "Today Prescriptions"
                            ])
                          }
                        </ToggleButton>
                        <ToggleButton
                          disabled={!selectedPatientData.id}
                          value="2"
                        >
                          {
                            t(DispensingLanguage[lan][menukey][
                              "Patient Prescriptions"
                            ])
                          }
                        </ToggleButton>
                        <ToggleButton value="3">
                          {
                            t(DispensingLanguage[lan][menukey][
                              "Prescriptions By Date"
                            ])
                          }
                        </ToggleButton>
                      </ToggleButtonGroup>
                    </Grid>

                    {/* {(toggleButtonValue == 2 || toggleButtonValue == 3) && ( */}
                    {toggleButtonValue == 3 && (
                      <Grid item xs={2} sm={2}>
                        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={lan === "en_GB" ? enGB : fr}>
                          <Grid container justifyContent="space-around">
                            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={lan === "en_GB" ? enGB : fr}>
                              <DatePicker
                                label={t(DispensingLanguage[lan][menukey]["From"])}
                                value={fromDate}
                                inputFormat="dd/MM/yyyy"
                                // onChange={(e) => setFromDate(e)}
                                onChange={(e) => fromDateChangeHandle(e)}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    variant="standard"
                                    id="fromDate-date-picker-dialog"
                                    name="fromDate"
                                    fullWidth
                                  />
                                )}
                              />
                            </LocalizationProvider>
                          </Grid>
                        </LocalizationProvider>
                      </Grid>
                    )}

                    {/* {(toggleButtonValue == 2 || toggleButtonValue == 3) && ( */}
                    {toggleButtonValue == 3 && (
                      <Grid item xs={2} sm={2}>
                        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={lan === "en_GB" ? enGB : fr}>
                          <DatePicker
                            label={t(DispensingLanguage[lan][menukey]["To"])}
                            value={toDate}
                            inputFormat="dd/MM/yyyy"
                            // onChange={(e) => setToDate(e)}
                            onChange={(e) => toDateChangeHandle(e)}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                variant="standard"
                                id="toDate-date-picker-dialog"
                                name="toDate"
                                fullWidth
                              />
                            )}
                          />
                        </LocalizationProvider>
                      </Grid>
                    )}

                    {/* {(toggleButtonValue == 2 || toggleButtonValue == 3) && ( */}
                    {toggleButtonValue == 3 && (
                      <Grid item xs={2} sm={2} className="defaulterBtn">
                        <FormControlLabel
                          control={
                            <Checkbox
                              color="primary"
                              onChange={(e) => handleCheckdefaulter(e)}
                              name="defaulter"
                              value="defaulter"
                            />
                          }
                          label={t(DispensingLanguage[lan][menukey]["Defaulter"])}
                        />
                      </Grid>
                    )}

                    {/* <Grid item xs={2} sm={2}>
                      <Button
                        variant="contained"
                        className="me-2 mb-3"
                        color="primary"
                        onClick={(e) => searchPrescriptionHandle(e)}
                      >
                        {t(DispensingLanguage[lan][menukey]["Search"])}
                      </Button>
                    </Grid> */}

                    {toggleButtonValue == 2 &&
                      selectedPatientData &&
                      selectedPatientData.id && (
                        <Grid className="float-end " item xs={4} sm={4}>
                          <Button
                            disabled={!!permissionType}
                            variant="contained"
                            className="me-2 mb-3"
                            color="primary"
                            onClick={(e) => addPrescriptionHandle(e)}
                          >
                            {
                              t(DispensingLanguage[lan][menukey][
                                "New Prescription"
                              ])
                            }
                          </Button>
                        </Grid>
                      )}

                    {(toggleButtonValue == 2 || toggleButtonValue == 3) && (
                      <Grid
                        item
                        xs={2}
                        sm={2}
                        className="defaulterBtn"
                        style={{ textAlign: "right" }}
                      >
                        <Button
                          style={{ marginTop: -16 }}
                          variant="contained"
                          className="me-2 sw_icons"
                          color="primary"
                          onClick={() => PrintPDFExcelExportFunction("print")}
                        >
                          <i className="fas fa-print"></i>
                        </Button>
                        <Button
                          style={{ marginTop: -16 }}
                          variant="contained"
                          className="me-2 sw_icons"
                          color="primary"
                          onClick={() => PrintPDFExcelExportFunction("excel")}
                        >
                          <i className="far fa-file-excel"></i>
                        </Button>
                      </Grid>
                    )}

                    {/* new row */}
                    <Grid item xs={12} sm={12}>
                      <div className="sw_relative">
                        {isLoadingPrescription && <LoadingSpinnerOpaque />}

                        <div className="uniqueName mb-2">
                          {/* {
                          
                          prescriptionData.data && prescriptionData.data.length > 0 && <ReactTabulator
                            columns={prescriptionDetailColumns}
                            data={prescriptionData?.data}   
                            options={{ selectableRowsRangeMode: 'click', selectableRows: 1 }}
                            rowClick={(e, row) => prescriptionRowClick(e, row)}
                          />
                        } */}

                          <ReactTabulator
                            layout={"fitColumns"}
                            columns={prescriptionDetailColumns}
                            data={prescriptionData?.data}
                            height="400px"
                            options={{
                              selectableRowsRangeMode: "click",
                              selectableRows: 1,
                            }}
                            events={{
                              rowClick: (e, row) => prescriptionRowClick(e, row),
                              rowDblClick: (e, row) =>
                                prescriptionRowDoubleClick(e, row),
                            }}
                          />
                        </div>
                      </div>

                      {/* 
                      <div className="sw_relative">
                        {isLoadingPatient && <LoadingSpinnerOpaque />}

                        <div className="uniqueName">
                           <ReactTabulator
                            height="400px"
                            layout={"fitColumns"}
                            columns={columns}
                            data={data?data:[]}
                            options={{ selectableRowsRangeMode: 'click', selectableRows: 1 }}
                            rowClick={(e, row) => rowClick(e, row)}
                          /> 

                        </div>
                      </div> */}
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>

              {/*Prescription Items*/}
              <Card className="sw_card mt-3">
                <CardHeader
                  title={t(DispensingLanguage[lan][menukey]["Prescription Items"])}
                />
                <CardContent>
                  <Grid container spacing={0}>
                    {/* new row */}
                    <Grid item xs={12} sm={12}>
                      <div className="uniqueName mb-2">
                        <MaterialTable
                          tableRef={tableRef}
                          title=""
                          icons={Service.default.tableicons()}
                          columns={[
                            {
                              title: String(DispensingLanguage?.[lan]?.[menukey]?.["Sl#"] ?? "Sl#"),
                              field: "Sl",
                              width: "5%",
                              align: "center",
                            },
                            {
                              title: String(
                                DispensingLanguage?.[lan]?.[menukey]?.["Product Code"] ?? "Product Code"
                              ),
                              field: "ItemCode",
                              width: "20%",
                            },
                            {
                              title: String(
                                DispensingLanguage?.[lan]?.[menukey]?.["Product"] ?? "Product"
                              ),
                              field: "productName",
                              width: "75%",
                            },
                          ]}
                          onSearchChange={setQuery}
                          data={getPrescriptionItems(selectedPrescription)}
                          options={{
                            rowStyle: (rowData) => ({
                              backgroundColor:
                                selectedRow === rowData.tableData.id
                                  ? "#EEE"
                                  : "#FFF",
                            }),
                            headerStyle: {
                              position: "sticky",
                              fontWeight: "bold",
                            },
                            search: false,
                            sorting: false,
                            paging: false,
                            actionsColumnIndex: 0,
                            toolbar: false,
                          }}
                          onRowClick={(evt, selectedRow) =>
                            setSelectedRow(selectedRow.tableData.id)
                          }
                          actions={
                            [
                              // {
                              //   icon: Service.default.tableicons().Edit,
                              //   tooltip: "View/Edit",
                              //   onClick: (event, rowData) => editPrescription(rowData),
                              // },
                              // {
                              //   icon: Service.default.tableicons().Delete,
                              //   tooltip: "Delete User",
                              //   onClick: (event, rowData) => deleteRole(rowData),
                              // },
                            ]
                          }
                        />
                      </div>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </div>
      </div>
    </>
  );
};

export default Prescription;

const useStyles = makeStyles({
  productPageTitle: {
    marginTop: "60px",
    color: "white",
    background: "whitesmoke",
    color: "black",
    borderRadius: "10px",
    padding: "1rem",
  },
  tableContainer: { backgroundColor: "whitesmoke", borderRadius: "10px" },
  fullWidth: {
    width: "95%",
  },
  filterDiv: {
    width: "80%",
    display: "flex",
  },
});
